






import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Tag from "@/components/miscellaneous/Tag.vue";

interface CatalogCompensation {
    isValidated: boolean;
}

@Component({ components: { Tag } })
export default class Status extends Vue {
    @Prop( { default: null }) public catalogCompensation!: CatalogCompensation;

    public static getNeededFields(): string[] {
        return [
            "catalog.isValidated",
        ];
    }
}
